module.exports = __webpack_public_path__ + "static/media/June_2026_3.44660dc1.webp";